/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  CnsDashboard,
  CnsLogRequest,
  CnsLogResponse,
  PidSimulationContestationRequest,
  PidSimulationContestationResponse,
  PidSimulationRequest,
  PidSimulationResponse,
  PidSimulationValidationRequest,
  PidSimulationValidationResponse,
  RaCancelMhRequest,
  RaCancelMhResponse,
  RaSendMhRequest,
  RaSendMhResponse,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    CnsDashboardFromJSON,
    CnsDashboardToJSON,
    CnsLogRequestFromJSON,
    CnsLogRequestToJSON,
    CnsLogResponseFromJSON,
    CnsLogResponseToJSON,
    PidSimulationContestationRequestFromJSON,
    PidSimulationContestationRequestToJSON,
    PidSimulationContestationResponseFromJSON,
    PidSimulationContestationResponseToJSON,
    PidSimulationRequestFromJSON,
    PidSimulationRequestToJSON,
    PidSimulationResponseFromJSON,
    PidSimulationResponseToJSON,
    PidSimulationValidationRequestFromJSON,
    PidSimulationValidationRequestToJSON,
    PidSimulationValidationResponseFromJSON,
    PidSimulationValidationResponseToJSON,
    RaCancelMhRequestFromJSON,
    RaCancelMhRequestToJSON,
    RaCancelMhResponseFromJSON,
    RaCancelMhResponseToJSON,
    RaSendMhRequestFromJSON,
    RaSendMhRequestToJSON,
    RaSendMhResponseFromJSON,
    RaSendMhResponseToJSON,
} from '../models/index';

export interface GetCnsDashboardRequest {
    financialgroupId: number;
    startDate?: string;
    endDate?: string;
}

export interface PostCreateCnsLogRequest {
    cnsLogRequest?: CnsLogRequest;
}

export interface PostPIDSimulationRequest {
    pidSimulationRequest?: PidSimulationRequest;
}

export interface PostPIDSimulationContestationRequest {
    simulationId: string;
    pidSimulationContestationRequest?: PidSimulationContestationRequest;
}

export interface PostPIDSimulationValidationRequest {
    simulationId: string;
    pidSimulationValidationRequest?: PidSimulationValidationRequest;
}

export interface PostRaCancelMhRequest {
    raCancelMhRequest?: RaCancelMhRequest;
}

export interface PostRaSendMhRequest {
    raSendMhRequest?: RaSendMhRequest;
}

/**
 * 
 */
export class CNSApi extends runtime.BaseAPI {

    /**
     * GET CNS dashboard for personId
     * GET CNS dashboard for personId
     */
    async getCnsDashboardRaw(requestParameters: GetCnsDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CnsDashboard>> {
        if (requestParameters['financialgroupId'] == null) {
            throw new runtime.RequiredError(
                'financialgroupId',
                'Required parameter "financialgroupId" was null or undefined when calling getCnsDashboard().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/cns/financial-group/{financialgroup_id}/dashboards`.replace(`{${"financialgroup_id"}}`, encodeURIComponent(String(requestParameters['financialgroupId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CnsDashboardFromJSON(jsonValue));
    }

    /**
     * GET CNS dashboard for personId
     * GET CNS dashboard for personId
     */
    async getCnsDashboard(requestParameters: GetCnsDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CnsDashboard> {
        const response = await this.getCnsDashboardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * POST creation of a CNS log
     * POST creation of LuLogTable
     */
    async postCreateCnsLogRaw(requestParameters: PostCreateCnsLogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CnsLogResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/cns/cns-logs`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CnsLogRequestToJSON(requestParameters['cnsLogRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CnsLogResponseFromJSON(jsonValue));
    }

    /**
     * POST creation of a CNS log
     * POST creation of LuLogTable
     */
    async postCreateCnsLog(requestParameters: PostCreateCnsLogRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CnsLogResponse> {
        const response = await this.postCreateCnsLogRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * POST simulation for a PID
     * POST simulation for a PID
     */
    async postPIDSimulationRaw(requestParameters: PostPIDSimulationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PidSimulationResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/cns/pid/simulations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PidSimulationRequestToJSON(requestParameters['pidSimulationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PidSimulationResponseFromJSON(jsonValue));
    }

    /**
     * POST simulation for a PID
     * POST simulation for a PID
     */
    async postPIDSimulation(requestParameters: PostPIDSimulationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PidSimulationResponse> {
        const response = await this.postPIDSimulationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * POST simulation contestation for a PID
     * POST simulation contestation for a PID
     */
    async postPIDSimulationContestationRaw(requestParameters: PostPIDSimulationContestationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PidSimulationContestationResponse>> {
        if (requestParameters['simulationId'] == null) {
            throw new runtime.RequiredError(
                'simulationId',
                'Required parameter "simulationId" was null or undefined when calling postPIDSimulationContestation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/cns/pid/simulations/{simulation_id}/contestation`.replace(`{${"simulation_id"}}`, encodeURIComponent(String(requestParameters['simulationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PidSimulationContestationRequestToJSON(requestParameters['pidSimulationContestationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PidSimulationContestationResponseFromJSON(jsonValue));
    }

    /**
     * POST simulation contestation for a PID
     * POST simulation contestation for a PID
     */
    async postPIDSimulationContestation(requestParameters: PostPIDSimulationContestationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PidSimulationContestationResponse> {
        const response = await this.postPIDSimulationContestationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * POST simulation validation for a PID
     * POST simulation validation for a PID
     */
    async postPIDSimulationValidationRaw(requestParameters: PostPIDSimulationValidationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PidSimulationValidationResponse>> {
        if (requestParameters['simulationId'] == null) {
            throw new runtime.RequiredError(
                'simulationId',
                'Required parameter "simulationId" was null or undefined when calling postPIDSimulationValidation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/cns/pid/simulations/{simulation_id}/validate`.replace(`{${"simulation_id"}}`, encodeURIComponent(String(requestParameters['simulationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PidSimulationValidationRequestToJSON(requestParameters['pidSimulationValidationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PidSimulationValidationResponseFromJSON(jsonValue));
    }

    /**
     * POST simulation validation for a PID
     * POST simulation validation for a PID
     */
    async postPIDSimulationValidation(requestParameters: PostPIDSimulationValidationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PidSimulationValidationResponse> {
        const response = await this.postPIDSimulationValidationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * POST cancel MH for a RA
     * POST cancel MH for a RA
     */
    async postRaCancelMhRaw(requestParameters: PostRaCancelMhRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RaCancelMhResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/cns/ra/cancel-mh`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RaCancelMhRequestToJSON(requestParameters['raCancelMhRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RaCancelMhResponseFromJSON(jsonValue));
    }

    /**
     * POST cancel MH for a RA
     * POST cancel MH for a RA
     */
    async postRaCancelMh(requestParameters: PostRaCancelMhRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RaCancelMhResponse> {
        const response = await this.postRaCancelMhRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * POST send MH for a RA
     * POST send MH for a RA
     */
    async postRaSendMhRaw(requestParameters: PostRaSendMhRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RaSendMhResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/cns/ra/send-mh`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RaSendMhRequestToJSON(requestParameters['raSendMhRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RaSendMhResponseFromJSON(jsonValue));
    }

    /**
     * POST send MH for a RA
     * POST send MH for a RA
     */
    async postRaSendMh(requestParameters: PostRaSendMhRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RaSendMhResponse> {
        const response = await this.postRaSendMhRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
